import styled from "styled-components";

export const BarStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const CardStyled = styled.div`
  flex: 1;
  border: 1px solid ${(p) => p.theme?.colors?.border ?? "#D8DAE5"};
  border-radius: 8px;
  padding: 3px 14px;
  text-align: center;
  background: ${(p) => p.$bg || "#fff"};
`;

export const NumStyled = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${(p) => p.$color || "#202124"};
  line-height: 1.1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;

export const LabelStyled = styled.div`
  font-size: 11.5px;
  color: #5a6a7a;
  margin-top: 1px;
`;

export const EditingRowStyled = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: center;
`;

// "Projected budget is $X under/over target." — the one line under the cards.
export const VarianceNoteStyled = styled.div`
  margin-top: 8px;
  font-size: 12.5px;
  color: ${(p) => p.theme?.colors?.textSecondary ?? "#5A6A7A"};
`;
